import { useMutation, useQuery, useQueryClient } from 'react-query';
import ky from 'ky';
import { Episode, PromptCollection } from '../@types';
import * as Constants from '../constants';
import { api, ApiResponse, throwError } from './BaseApi';

const cache = {
  EPISODE: 'episode',
  EPISODE_PROGRESS: 'episodeProgress',
};

export const getEpisodeById = async (episodeId: string) => {
  const episode: any = await api.get(`episodes/view/${episodeId}`).json();
  return episode as Episode;
};

export const useEpisode = (episodeId: string) =>
  useQuery([cache.EPISODE, episodeId], () => getEpisodeById(episodeId));
